<!--GuidePage:没有导入班级信息的引导页面 2021/03/04 16:20:08 YuAng-->

<template>
  <ts-page-layout center>
    <ts-div-guide-page style="margin-top: 20px" :item=item></ts-div-guide-page>
  </ts-page-layout>
</template>
<script>
export default {
  name: 'GuidePage',
  data() {
    const guide = {
      zjw: {
        name: '作业',
        desc: '作业任务快速布置,学生答案自动批改,精准了解学生学情',
        src: 'https://e.xkw.com/ibook/other/ektcxb/%E4%BD%9C%E4%B8%9A0714.mp4'
      },
      classpace: {
        name: '班级资料',
        desc: '上传学生学习资料并分享给学生，再也不用担心学生遗失复习资料啦',
        src: 'https://e.xkw.com/ibook/other/ektcxb/%E7%8F%AD%E7%BA%A7%E8%B5%84%E6%96%99%E5%BC%95%E5%AF%BC%E8%A7%86%E9%A2%91.mp4'
      },
    }
    const target = guide[this.$route.query.name]
    return {
      item: {
        empty: '您还没有设置任教信息',
        guides: {
          part1: [
            '<p style="text-align: center;">请联系<span style="color: #0076f1;" id="setting">400-900-2556</span>为您设置任教,即可使用' + target.name + '哦</p>'
          ],
          part2: [
            '<p style="color: #333333;font-size: 20px;font-weight:bold">' + target.desc + '</p>'
          ]
        },
        file: {
          type: 'video',
          urls: [target.src] // 绝对地址
        }
      }
    }
  },
  created () {
    if (this.$route.query.type === 'no_class') {
      this.item.empty = '您所在的学校还没有班级信息哦~'
      this.item.guides.part1[0] = '<p style="text-align: center;">您可以咨询客服<span style="color: #0076f1;">400-900-2556</span>辅助您导入班级信息</p>'
    }
  }
}
</script>
